import { defineMessages } from "react-intl"

export default defineMessages({
  role: {
    id: "admin.user.profile.super.role",
    defaultMessage: "Role"
  },
  userProfileLabel: {
    id: "admin.user.profile.label",
    defaultMessage: "Profile"
  },
  staff: {
    id: "admin.user.profile.admin",
    defaultMessage: "Admin"
  },
  normal: {
    id: "admin.user.profile.customer",
    defaultMessage: "Customer"
  },
  technical: {
    id: "admin.user.profile.technical",
    defaultMessage: "Technical"
  },
  confirmDeletedProfiles: {
    id: "admin.user.profile.deleteMany.confirmation",
    defaultMessage: "Are you sure you want to delete ({size}) profile(s)?"
  },
  userProfileManagement: {
    id: "admin.user.profile.title",
    defaultMessage: "User profile management"
  },
  userProfile: {
    id: "admin.user.profile",
    defaultMessage: "Users profiles"
  },
  infoBoxContent: {
    id: "admin.user.profile.info.content",
    defaultMessage:
      // FIXME SR : ajouter une explication sur comment les profils peuvent être synchronisés
      "User profiles make it possible to restrict access to certain features. For example, it is possible to limit access to certain private pages based on user profile."
  },
  newUserProfile: {
    id: "admin.user.profile.new.title",
    defaultMessage: "New user profile"
  },
  editUserProfile: {
    id: "admin.user.profile.edit.title",
    defaultMessage: "Edit user profile"
  },
  transferUserProfile: {
    id: "admin.user.profile.available.title",
    defaultMessage: "Profiles list"
  },
  transferSelectedUserProfile: {
    id: "admin.user.profile.selected.title",
    defaultMessage: "Profiles with authorization"
  }
})
